module.exports = __webpack_public_path__ + "static/media/step-indicator-1of2.bd50c4b1.svg";